import React from 'react';
import PropTypes from 'prop-types';
// mui
import { Box, MenuItem, Typography, useTheme } from '@mui/material';
import { primary } from 'src/theme/palette';
// components
import { Scrollbar, Iconify } from '../../../../components';
import { primaryTypographyPropsStyle, treatmentEditPopupListItem } from '../../../../styles/LeadDetailView';

const PracticePopoverScrollbar = ({
    selected,
    handleScroll,
    handleTreatmentSelect,
    practices
}) => {
    const theme = useTheme();

    const getMargin = (isStarred) => {
        if (isStarred) return {};
        return { ml: 4 };
    };

    return (
        <Box sx={{ margin: '8px 0 0' }}>
            <Scrollbar sx={{ maxHeight: 70 * 5, minHeight: 70 * 5 }} onScroll={handleScroll}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                    {practices?.map((row, index) => (
                        <>
                            <MenuItem
                                onClick={() => handleTreatmentSelect(row)}
                                value={row?.name}
                                key={`${row?.id}-${index}`}
                                sx={treatmentEditPopupListItem(selected, row, theme)}
                            >
                                <img
                                    src={row?.logo}
                                    alt="practice-logo"
                                    style={{ maxHeight: '2rem', maxWidth: "2rem", objectFit: 'contain' }}
                                />
                                <Typography sx={{ ...primaryTypographyPropsStyle, mb: 0, ...getMargin(row?.is_starred) }}>{row?.name}</Typography>
                                {row?.name === selected && (
                                    <Iconify
                                        icon={'ic:sharp-check'}
                                        width={24}
                                        height={24}
                                        sx={{ mr: 1, fontWeight: 400, color: primary.main, marginLeft: 'auto' }}
                                    />
                                )}
                            </MenuItem>
                        </>
                    ))}
                </Box>
            </Scrollbar>
        </Box>
    );
};

export default PracticePopoverScrollbar;

PracticePopoverScrollbar.propTypes = {
    selected: PropTypes.string,
    handleScroll: PropTypes.func,
    handleTreatmentSelect: PropTypes.func,
    practices: PropTypes.object
};
